var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlassIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0828 44.3107L59.5042 55.7294L55.7308 59.5027L44.3122 48.0814C40.0635 51.4873 34.7788 53.3398 29.3335 53.332C16.0855 53.332 5.3335 42.58 5.3335 29.332C5.3335 16.084 16.0855 5.33203 29.3335 5.33203C42.5815 5.33203 53.3335 16.084 53.3335 29.332C53.3412 34.7774 51.4888 40.062 48.0828 44.3107ZM42.7335 42.332C46.1178 38.8517 48.0078 34.1865 48.0002 29.332C48.0002 19.0174 39.6455 10.6654 29.3335 10.6654C19.0188 10.6654 10.6668 19.0174 10.6668 29.332C10.6668 39.644 19.0188 47.9987 29.3335 47.9987C34.188 48.0063 38.8532 46.1163 42.3335 42.732L42.7335 42.332Z",
    fill: "#18223D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassIcon);
export default __webpack_public_path__ + "static/media/glass_icon.aa81e188ff6254f5d734bd185cbb69dd.svg";
export { ForwardRef as ReactComponent };